import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ModalUpdateFormatHour extends Component {
    constructor(props) {
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            form: {
                custom_format: this.props.question.custom_format || '12h',
            }
        }
    }

    handleSubmit = e => {
        e.preventDefault();
    };

    handleChangeUpdate = (e) => {
        const form = { custom_format: e.target.value }
        fetch(`/formatos/questions/${this.props.question.id}`, {
            method: 'PATCH',
            body: JSON.stringify(form),
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(res => res.json())
        .catch(error => console.error("Error:", error))
        .then(data => {
            this.props.update_question(data.register);
            this.setState({
                form: {
                    custom_format: data.register.custom_format
                }
            })
        });
    }

    render() {
        return (
            <React.Fragment>
                <Modal isOpen={this.props.modal} toggle={this.props.toggle} className="modal-dialog-centered" backdrop={this.props.backdrop}>
                    <ModalHeader toggle={this.props.toggle}>
                        <div className='ui-modals-header-title__container'>
                            <span className='ui-titles_modals'>{this.props.title}</span>
                            <span className='ui-name-question-modals'>Pregunta {this.props.question.question}</span>
                        </div>
                    </ModalHeader>

                    <form onSubmit={this.handleSubmit}>
                        <ModalBody>
                            <div className="row">
                                <div className={`col-md-12`}>
                                    <select
                                        name="value"
                                        className="form form-control"
                                        onChange={this.handleChangeUpdate}
                                        value={this.state.form.custom_format}
                                    >
                                        <option value="24h">24 horas (14:30)</option>
                                        <option value="12h">12 horas (02:30 PM)</option>
                                    </select>
                                </div>
                            </div>
                        </ModalBody>

                        <ModalFooter>
                            <button className="btn btn-outline-danger" onClick={() => this.props.toggle()}>Cerrar</button>
                        </ModalFooter>
                    </form>
                </Modal>
            </React.Fragment>
        );
    }
}

export default ModalUpdateFormatHour;
